import React, { memo } from 'react'
import { Element } from 'react-bulma-components'
import { AvailableWorker, User } from '../../api/users'
import { getUserLabel } from '../../utils/users'
import uniqBy from 'lodash/uniqBy'

export type AvatarProps = {
  user: User | AvailableWorker
  small?: boolean
  backgroundColor?: string
  onClick?: (user: AvatarProps['user']) => void
  dataTest?: string
}

const Avatar: React.FC<AvatarProps> = ({ user, small, backgroundColor, onClick, dataTest }) => {
  const { firstName, lastName } = user
  const [initials, fullName] = React.useMemo(
    () => [`${lastName?.charAt(0)}${firstName?.charAt(0)}`, getUserLabel(user)],
    [firstName, lastName],
  )

  if (small) {
    return (
      <Element
        renderAs={onClick ? 'button' : 'span'}
        backgroundColor={backgroundColor || `primary-dark`}
        textColor="primary-light"
        style={{ borderRadius: 999, padding: '0.5rem' }}
        data-tooltip={fullName}
        className="has-tooltip-bottom"
        onClick={onClick ? () => onClick(user) : undefined}
        data-test={dataTest}
      >
        {initials}
      </Element>
    )
  }
  return <>{fullName}</>
}

export default Avatar

type AvatarsListProps = Omit<AvatarProps, 'user'> & {
  users: Array<AvatarProps['user']>
}
export const AvatarsList = memo(({ users, ...rest }: AvatarsListProps) => {
  const unique = uniqBy(users, u => u._id)
  return (
    <>
      {unique.map(u => (
        <Avatar user={u} {...rest} />
      ))}
    </>
  )
})
